// src/lib/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Paste your own values here:
const supabaseUrl = 'https://kppjrvrwgubajxxcdkxj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtwcGpydnJ3Z3ViYWp4eGNka3hqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyMjUxOTksImV4cCI6MjA1ODgwMTE5OX0.77LlN7SFkTlIuLHCdFrPcW4anb9_dWwAQgjlGFhmVb8';
        
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
